import { RadioLabel, RadioContainer } from "./FormBondApp.styled";
import Datepicker from "../Datepicker/Datepicker";
import Radio from "../Radio/Radio";
import { Step } from "./FormBondApp.constants";
import styled from "styled-components";

export const CustomCheckbox = function (
  props: any,
  setBusiness: any,
  setApplicant: any,
  setStart: any,
  setStep: any
) {
  const isBusinessField = props.id === "root_is_business";

  return (
    <>
      {/* @ts-ignore */}
      <RadioLabel for={props.id}>
        {isBusinessField
          ? "Is this for the individual above or for a business"
          : props.label}
        {props.required && <span>*</span>}
      </RadioLabel>
      <p className="field-description">{props?.schema?.description}</p>
      <RadioContainer>
        {!isBusinessField &&
          props.options.enumOptions.map((item: any, idx: number) => {
            const isLastElement = props.options.enumOptions.length - 1 === idx;

            return (
              <Radio
                id={props.id}
                onChange={props.onChange}
                name={`${props.id}_${item.label}`}
                value={item.value}
                onBlur={isLastElement && props.onBlur}
                label={item.label}
                isChecked={item.value === props.value}
              />
            );
          })}
        {isBusinessField && (
          <>
            <Radio
              id={props.id}
              name="business"
              value="business"
              isChecked={props.value}
              onChange={() => {
                setStep(Step.BOND_BUSINESS);
                setBusiness((data: any) => ({
                  ...data,
                  is_business: true,
                }));
                setStart({ is_business: true });
                setTimeout(() => {
                  document?.getElementById("root_business_name")?.focus();
                }, 0);
              }}
              label="Business"
            />
            <Radio
              id={props.id}
              name="individual"
              value="individual"
              isChecked={!props.value && props.value !== undefined}
              onBlur={props.onBlur}
              onChange={() => {
                setStep(Step.BOND_APPLICANT);
                setApplicant((data: any) => ({
                  ...data,
                  is_business: false,
                }));
                setStart({ is_business: true });
                setTimeout(() => {
                  document?.getElementById("root_phone")?.focus();
                }, 0);
              }}
              label="Individual"
            />
          </>
        )}
      </RadioContainer>
    </>
  );
};

export {default as CustomSelect} from "./CustomSelect";
export {default as CurrencyWidget} from "./CurrencyWidget";

export const CustomDatePicker = (props: any) => {
  return <Datepicker {...props} />;
};

const StyledCheckboxLabel = styled.label`
  display: flex !important;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5em;
  color: var(--text);
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const StyledCheckboxIndicator = styled.span<{ isChecked: boolean }>`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-right: 15px;
  cursor: pointer;
  background-color: ${({ isChecked }) =>
    isChecked ? "var(--radio-background-selected)" : "var(--color-white)"};
  border: 1px solid;
  border-color: ${({ isChecked }) =>
    isChecked ? "rgba(112, 112, 112, 0.3)" : "rgba(0, 0, 0, 0.3)"};
  border-radius: 3px;
  transition: 0.4s;
  aspect-ratio: 1/1;

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -60%) rotate(45deg) scale(0);
    display: block;
    width: 15px;
    height: 30px;
    border-right: 5px solid white;
    border-bottom: 5px solid white;
    transition: 0.4s;
  }
`;

const StyledCheckboxInput = styled.input`
  position: absolute;
  width: 0.1px;
  height: 0.1px;
  z-index: -1;
  opacity: 0;
  transition: 0.4s;

  &:hover + ${StyledCheckboxIndicator},
  &:focus + ${StyledCheckboxIndicator} {
    border-color: var(--primary);
  }

  &:checked + ${StyledCheckboxIndicator}::before {
    transform: translate(-50%, -60%) rotate(45deg) scale(1);
  }
`;

export const SingleCheckboxWidget = (props: any) => {
  const isChecked = !!props.value;
  return (
    <StyledCheckboxLabel>
      <StyledCheckboxInput
        type="checkbox"
        id={props.id}
        name={props.id}
        checked={isChecked}
        onChange={(e) => props.onChange(e.target.checked)}
        onBlur={() => props.onBlur && props.onBlur(props.id, props.value)}
      />
      <StyledCheckboxIndicator isChecked={isChecked} />
      {props.label}
    </StyledCheckboxLabel>
  );
};
